module.exports = __webpack_public_path__ + "img/square-dotted.9f4dbb99.svg";